import '../../../../assets/img/flag-by.png';
import '../../../../assets/img/flag-de.png';
import '../../../../assets/img/flag-tr.png';
import '../../../../assets/img/flag-ua.png';

import { Transition } from '@uirouter/core';
import { IFormController, IWindowService } from 'angular';
import { Action } from '../../../common/actions/core/action';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../../common/actions/core/action-handler';
import { LoginAttemptRejection } from '../../../common/services/auth/auth.model';
import AuthService from '../../../common/services/auth/auth.service';
import SecuredStorage from '../../../common/services/local-storage/secured-storage.service';
import GlobalSpinnerService from '../../../common/services/spinner/global-spinner.service';
import { UserResponse } from '../../../common/services/user/user.model';
import UserService from '../../../common/services/user/user.service';

import {
  CloseLoginDialogAction,
  OpenLoginDialogAction,
  OpenRegisterDialogAction,
  ResetLoginFormAction
} from '../login-dialog.action';

const storageKey = 'user-phonenumber';
const codeKey = 'user-phonecode';

/* @ngInject */
export default class LoginBoxController implements ActionHandler {
  public loginPhoneCode;
  public phoneNumber: string;
  public password: string;
  public captcha: string;
  public captchaUrl: string;
  public rememberMe: boolean;
  public error: string;
  public phoneCodes;
  public dropDownState: boolean;

  public onReset: any;

  private loginForm: IFormController;
  private transition: Transition;
  constructor(
    public config,
    private authService: AuthService,
    private $element,
    private $scope,
    private $state,
    private i18n,
    private actionDispatcher: ActionDispatcherService,
    private securedStorage: SecuredStorage,
    private userService: UserService,
    private globalSpinner: GlobalSpinnerService
  ) {}

  public $onInit() {
    this.phoneCodes = this.config.countries;
    this.loginPhoneCode =
      this.securedStorage.get(codeKey) ||
      this.resolvePhoneCode(this.userService.getTerritory());

    this.phoneNumber = this.securedStorage.get(storageKey);
    this.rememberMe = !!this.phoneNumber;
  }

  public chooseCode(code) {
    this.loginPhoneCode = code;
    this.dropDownState = false;
  }

  public showDropDown() {
    this.dropDownState = !this.dropDownState;
  }

  public hideDropDown() {
    this.dropDownState = false;
  }

  public $postLink() {
    angular.element(() => {
      this.loginForm = this.$scope.loginForm;
      this.actionDispatcher.register(this);
    });
  }

  public onRegister() {
    this.actionDispatcher.dispatch(
      new OpenRegisterDialogAction(this.loginPhoneCode.territoryCode)
    );
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
  }

  public handle(action: Action) {
    if (action instanceof OpenLoginDialogAction) {
      this.transition = action.transition;
    }

    if (action instanceof ResetLoginFormAction) {
      this.resetForm();
    }
  }

  public login() {
    this.globalSpinner.start();
    if (this.rememberMe) {
      this.securedStorage.set(codeKey, this.loginPhoneCode);
      this.securedStorage.set(storageKey, this.phoneNumber);
    } else {
      this.securedStorage.remove(codeKey);
      this.securedStorage.remove(storageKey);
    }

    this.authService
      .login(
        `${this.loginPhoneCode.value}${this.phoneNumber}`,
        this.password,
        this.rememberMe,
        this.captcha
      )
      .then((user: UserResponse) => {
        this.userService.resetCache();
        this.userService.setTerritory(this.loginPhoneCode.territoryCode);
        this.actionDispatcher.dispatch(new CloseLoginDialogAction());
        this.goToTargetState();
      })
      .catch((loginAttemptRejection: LoginAttemptRejection) => {
        this.onLoginError(loginAttemptRejection);
      })
      .finally(() => {
        this.globalSpinner.stop();
      });
  }

  public resetForm() {
    this.onReset();
    this.reset();
  }

  public updateCaptcha(reset: boolean = false) {
    this.captchaUrl = reset ? null : this.authService.getUniqueCaptchaUrl();
  }

  private reset() {
    this.password = null;
    this.phoneNumber = null;
    this.captcha = null;
    this.updateCaptcha(true);
    this.error = null;
    this.loginForm.$setPristine();
    this.loginForm.$setUntouched();
  }

  private onLoginError(loginAttemptRejection: LoginAttemptRejection) {
    if (loginAttemptRejection.reason.code === '4') {
      this.error = this.i18n.getTranslation('login.error.required.captcha');
    } else if (
      loginAttemptRejection.reason.code === '2' ||
      loginAttemptRejection.reason.code === '103'
    ) {
      this.error = this.i18n.getTranslation('login.error.credentials');
    } else if (loginAttemptRejection.reason.code === '5') {
      this.error = this.i18n.getTranslation('login.error.captcha');
    } else {
      this.error = this.i18n.getTranslation('login.error.credentials');
    }
    this.updateCaptcha(!loginAttemptRejection.captchaRequired);
  }

  private rememberUser() {
    if (this.rememberMe) {
      this.securedStorage.set(codeKey, this.loginPhoneCode);
      this.securedStorage.set(storageKey, this.phoneNumber);
    } else {
      this.securedStorage.remove(codeKey);
      this.securedStorage.remove(storageKey);
    }
  }

  private goToTargetState(): void {
    if (this.transition) {
      this.$state.go(
        this.transition.targetState().name(),
        this.transition.targetState().params()
      );
    } else if ('login' === this.$state.current.name) {
      this.$state.go('myAccount');
    }
  }

  private resolvePhoneCode(territory: string) {
    let targetPhoneCode;

    if (territory) {
      targetPhoneCode = this.phoneCodes.filter(
        phoneCode =>
          phoneCode.territory.toLowerCase() === territory.toLowerCase()
      )[0];
    }

    return targetPhoneCode || this.phoneCodes[0];
  }
}



// WEBPACK FOOTER //
// ./src/app/components/login-dialog/login-box/login-box.controller.ts